module.exports = __webpack_public_path__ + "media/images/backgrounds/how_to/top-03e2e2cfc3a3d8b603356a43f44e5ec2.svg";